import {NumberUDF} from "./UDFs/NumberUDF";
import {StringUDF} from "./UDFs/StringUDF";

export class UnassociatedConfiguration {

  DefaultPowerLevel: NumberUDF;

  ProximityAcceptanceCriteria: NumberUDF;

  ReportUnassociatedId: NumberUDF;

  FilterLabelZoneType: StringUDF;

  FilterLabelStoreID: StringUDF;

  get(): any {
    return {
      DefaultPowerLevel: this.DefaultPowerLevel.value,
      ProximityAcceptanceCriteria: this.ProximityAcceptanceCriteria.value,
      ReportUnassociatedId: this.ReportUnassociatedId.value,
      FilterLabelZoneType: this.FilterLabelZoneType.value,
      FilterLabelStoreID:this.FilterLabelStoreID
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/unassociated.config.ts